module.exports = __webpack_public_path__ + "assets/img/game-images-loader.a9a82a65.svg";